<template>
  <footer
    class="config__form_controls"
    :class="{
      'config__form_controls--fixed': fixed,
      'config__form_controls--offset_left': offset === 'left',
      'config__form_controls--offset_right': offset === 'right',
    }"
    :style="offsetStyling"
  >
    <slot></slot>
  </footer>
</template>

<script>
export default {
  name: "FormFooter",
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: String,
      required: false,
    },
    offsetInPixels: {
      type: Number,
      required: false,
    },
  },
  computed: {
    offsetStyling() {
      if (this.offset === null || !this.fixed) return "";

      return `width: calc(100% - ${this.offsetInPixels}px)`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style_variables/style_variables.scss";

.config__form_controls {
  width: 100%;
  height: 96px;
  background: $white;
  border-top: 1px solid $grey_alabaster;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px -5px 20px 0px rgba(30, 30, 30, 0.05);
  z-index: 2;
  @media (max-width: 1000px) {
    width: 100%;
  }

  &.config__form_controls--fixed {
    position: fixed;
    bottom: 0;
  }

  &.config__form_controls--offset_left {
    right: 0;
  }

  &.config__form_controls--offset_right {
    left: 0;
  }
}
</style>
